import axios from "axios";

export default {
    namespaced: true,

    state: {},

    mutations: {},

    actions: {
        find(_, id) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/payments/${id}`)
                    .then((res) => {
                        resolve(res.data.data.payment);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        save(_, paymentForm) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/payments", paymentForm)
                    .then((res) => {
                        resolve(res.data.data.payment);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        delete(_, paymentId) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/payments/${paymentId}`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        restore(_, paymentId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/payments/${paymentId}/restore`)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        changeStatus(_, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/payments/${payload.id}/status`, payload)
                    .then((res) => {
                        resolve(res.data.data.payment);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    },
};
